<template>
    <div class="layouts">
      <navbar :company="company"></navbar>
      <router-view></router-view>
      <footerbar :company="company"></footerbar>
      <el-backtop :bottom="100">
        <div
          style="{
            height: 100%;
            width: 100%;
            background-color: #edf1ff;
            box-shadow: 0 0 6px rgb(57 124 236 / 12%);
            text-align: center;
            line-height: 40px;
            color: #3964E6;
            font-size:24px;
          }"
        >
          <i class="el-icon-caret-top"></i>
        </div>
      </el-backtop>
    </div>
</template>
<script>
import Navbar from "@/components/Navbar"
import Footerbar from "@/components/Footerbar"
import { getCompany } from '@/api/user'
export default {
    name:'Layout',
    data(){
        return{
          company:{}
        }
    },
    components:{
      Navbar,Footerbar
    },
    created(){
      getCompany().then(res=>{
        this.company = res.data
        this.$store.commit('user/SET_ABOUTUS',this.company.companyAbout)
        this.$store.commit('user/SET_BANNER',{banner1:this.company.companyBanner1,banner2:this.company.companyBanner2})
        this.$store.commit('user/SET_COMPANY',this.company)
      })
    },
    mounted(){
     
    },
    methods:{
    
    }
}
</script>
